import { SavingsWrapper } from './SavingsStyle'
import { TitleWrapper } from 'src/components/Global/Text/TitleText'
import { Balance } from 'src/assets'
import { SavingsTypes } from './SavingsTypes'
import { addNairaSign } from 'src/utils/addNairaSign'
import useUserData from 'src/hooks/useUserData'
const Savings = () => {
  const userData = useUserData()
  return (
    <SavingsWrapper>
      <div className="savings-btn-container">
        <TitleWrapper>Savings</TitleWrapper>
      </div>
      <div className="saving-card">
        <img src={Balance} className="increase-icon" alt="" />
        <div className="card-title">
          <p>Total savings</p>
          <h2>{userData.user.accounts.available_balance}</h2>
        </div>
      </div>
      <SavingsTypes />
    </SavingsWrapper>
  )
}
export { Savings }
